<div
  *ngIf="!dataset.encrypted; else encryptedCell"
  class="encryption-description"
>
  {{ 'Unencrypted' | translate }}
</div>
<ng-template #encryptedCell>
  <ng-container *ngIf="dataset.locked; else unlockedCell">
    <ix-icon
      [name]="'mdi-lock' + (isEncryptionRoot ? '' : '-outline')"
    ></ix-icon>
    <div class="encryption-description">
      <div>{{ 'Locked' | translate }}</div>
      <div *ngIf="!isEncryptionRoot" class="by-ancestor">
        {{ 'by ancestor' | translate }}
      </div>
    </div>
  </ng-container>

  <ng-template #unlockedCell>
    <ix-icon
      [name]="'mdi-lock-open-variant' + (isEncryptionRoot ? '' : '-outline')"
    ></ix-icon>
    <div class="encryption-description">
      <div>{{ 'Unlocked' | translate }}</div>
      <div *ngIf="!isEncryptionRoot" class="by-ancestor">
        {{ 'by ancestor' | translate }}
      </div>
    </div>
  </ng-template>
</ng-template>
